<template>
  <div>
    <div v-for="(value, key) in inputs" :key="key">
      <h5>{{ formatKey(key) }}</h5>
      
      <div v-for="(item, itemKey) in value" :key="itemKey" class="row">
        <div class="col-6">
          {{ item.description }} {{ itemKey }}:
        </div>
        <div class="col-6">
          <input 
            type="text" 
            :value="formData[key]?.[itemKey]"
            @input="updateFormData(key, itemKey, $event.target.value)"
            class="form-control"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { reactive } from 'vue';

export default {
  data() {
    return {
      inputs: { 
        "member_dimensions": {
          "b": {
            "description": "Width of the member cross-section",
            "value": 200, 
            "units": "mm"
          }, 
          "d": {
            "description": "Depth of the member cross-section",
            "value": 100, 
            "units": "mm"
          }
        },
      },
      formData: reactive({})
    }
  },
  created() {
    this.initializeFormData();
  },
  watch: {
    inputs: function(inputs) {
      console.log("Inputs changed:", inputs);
    }
  },
  methods: {
    formatKey(key) {
      return key
        .split('_')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
    },
    initializeFormData() {
      for (let key in this.inputs) {
        this.formData[key] = {};
        for (let itemKey in this.inputs[key]) {
          this.formData[key][itemKey] = this.inputs[key][itemKey].value;
        }
      }
    },
    updateFormData(key, itemKey, value) {
      if (!this.formData[key]) {
        this.formData[key] = {};
      }
      this.formData[key][itemKey] = value;
    }
  }
}
</script>